import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  CLOSE_WARNING_BUTTON: `${cleanedFilename(__filename)}-close-warning-button`,
};
